// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"3c4ee03b1cf083c1","5285":"eab634325eb0437e"}[chunkId] + ".css";
};